import { tw } from "@sveabank/cc-common";

type Props = {
	excludeFirst?: boolean;
	padding?: boolean;
	children?: React.ReactNode;
};

const BorderDivider = ({ excludeFirst = true, padding = true, children }: Props) => {
	const styling = tw(
		"flex w-full border-t-2",
		padding && "px-4 py-8",
		excludeFirst && "first:border-t-0",
	);

	return <div className={styling}>{children}</div>;
};

export default BorderDivider;
